import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Header from './Header';
var Forbidden = function () { return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsx(Alert, { severity: "error", sx: { justifyContent: 'center' }, children: "You don't have access to this application. Please click the help button to contact Helpdesk and request access. If you're granted the required permissions please log out and log in again." })] })); };
export default Forbidden;
